export default __webpack_public_path__ + "static/media/(66).1392a9eb.jpg";